import {
  SELECT_INVOICE,
  INVOICE_CREATE_REQUEST_FAIL,
  INVOICE_CREATE_REQUEST_SUCCESS,
  INVOICE_FIND_REQUEST_FAIL,
  INVOICE_FIND_REQUEST_SUCCESS,
  INVOICE_UPDATE_REQUEST_FAIL,
  INVOICE_UPDATE_REQUEST_SUCCESS
} from "../action.types";

import initialValue from "../initial.state";
import { toLocaleMoney } from "../../shared/utils/functional.utils";

export default function(state = initialValue.invoice, action) {
  switch (action.type) {
    case SELECT_INVOICE:
      return { ...action.invoice };
    case INVOICE_CREATE_REQUEST_SUCCESS:
      return state;
    case INVOICE_CREATE_REQUEST_FAIL:
      return state;
    case INVOICE_UPDATE_REQUEST_SUCCESS:
      return state;
    case INVOICE_UPDATE_REQUEST_FAIL:
      return state;
    case INVOICE_FIND_REQUEST_SUCCESS:
      const payload = action.payload;
      return {
        hirerId: payload.hirer.id,
        contractorName: {
          label: payload.hirer.fantasyName,
          value: payload.hirer.id
        },
        invoiceHirerBehalf: payload.invoiceHirerBehalf && {
          label: payload.invoiceHirerBehalf.fantasyName,
          value: payload.invoiceHirerBehalf.id
        },
        contractor: payload.hirer,
        contractorCnpj: payload.hirer.cnpj,
        dueDate: payload.dueDate,
        invoiceDeadLineDate: payload.invoiceDeadLineDate,
        id: payload.id,
        protocol: payload.protocol.value,
        status: payload.status,
        totalAmount: toLocaleMoney(payload.totalAmount),
        tranpoTotalAmount: toLocaleMoney(payload.tranpoTotalAmount),
        providersTotalAmount: toLocaleMoney(payload.providersTotalAmount),
        notes: payload.notes
      };
    case INVOICE_FIND_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/invoice/invoice.reducer.js